module.exports = __webpack_public_path__ + "opensource-forum-fe/static/img/emptyList.69d6522b.png";